import React from "react";
import { Link, ListItem,  ListItemText, List, ListSubheader, Stack, IconButton } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import CloseIcon from '@mui/icons-material/Close';
const RecallsFull = (props) => {


    
var {subject, associatedDocuments, components, notes, reportReceivedDate, 
    potentialNumberOfUnitsAffected, correctiveAction, consequence, summary, nhtsaCampaignNumber, 
    associatedDocumentsCount, associatedProductsCount, manufacturer, associatedProducts, setOpen} = props;

return (
    <List
        sx={{
            margin: 0,
            padding: 0,
            width: '100%',
            borderRadius: 2,
            borderColor: 'divider',
            backgroundColor: 'background.paper',
        }}
    >
         <Stack sx={{backgroundColor: "#e7e3e3", padding: "10px"}} justifyContent={"space-between"} direction={'row'} alignItems={'center'}>
            <ListItemText primary={subject} />
            <IconButton onClick={()=>setOpen(false)}><CloseIcon size="large" color="error"/></IconButton>
        </Stack>
        <ListItem>
            <ListItemText primary={`Manufacturer: ${manufacturer}`} secondary= {`${summary}`} />
        </ListItem>
        <ListItem>
            <ListItemText primary={`Consequence`} secondary= {`${consequence}`} />
        </ListItem>
        <ListItem>
            <ListItemText primary={`Corrective Action`} secondary= {`${correctiveAction}`} />
        </ListItem>
        <ListItem>
            <ListItemText primary={`Notes`} secondary= {`${notes}`} />
        </ListItem>
        <ListItem>
            <ListItemText primary="Nhtsa Campaign Number" secondary= {`${nhtsaCampaignNumber}`} />
            <ListItemText primary="Associated Documents" secondary= {`${associatedDocumentsCount}`} />
            <ListItemText primary="Affected Products" secondary= {`${associatedProductsCount}`} />
            <ListItemText primary="Manufacturer" secondary= {`${manufacturer}`} />
            <ListItemText primary="Potential Units Affected" secondary= {`${potentialNumberOfUnitsAffected}`} />
            <ListItemText primary="Report Received Date" secondary= {`${reportReceivedDate}`} />
            <ListItemText primary="Components" secondary= {`${components.map(c=>c.name)}`} />
        </ListItem>
        <ListItem sx={{backgroundColor: "#e7e3e3"}}>
            <ListItemText primary={`Associated Documents`} />
        </ListItem>
        {associatedDocuments.map((a, i)=>
            
                <Link key={i} href={`${a.url}`} underline="none" target="_blank">
                    <ListItem >
                    <ListSubheader><LaunchIcon /></ListSubheader>
                    <ListItemText primary={`${a.summary}`} secondary= {`${a.fileName}`} />
                    </ListItem>
                </Link>
            
        )}
        <ListItem sx={{backgroundColor: "#e7e3e3"}}>
            <ListItemText primary={`Affected Products`} />
        </ListItem>
        {associatedProducts.map((a, i)=>
            <ListItem key={i}>
                <ListSubheader>{a.type}</ListSubheader>
                <ListItemText primary={`Manufacturer: ${a.manufacturer}`} secondary= {`${a.productMake} / ${a.productModel} / ${a.size}`} />
            </ListItem>
        )}
    </List>
)}

export default RecallsFull;
